var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { attrs: { id: "FormList" } }, [
        _c("div", { staticClass: "header" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "header-text" }, [
            _c("h1", [_vm._v(_vm._s(_vm.$t("form.forms")))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("form.formsDesc")))]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          _vm._l(_vm.formsWithColors, function (form) {
            return _c(
              "div",
              {
                key: form._id,
                staticClass: "list-card",
                class: {
                  selected:
                    _vm.selectedForm && _vm.selectedForm._id === form._id,
                },
                style: { borderLeftColor: form.color },
                on: {
                  click: function ($event) {
                    return _vm.formId(form._id)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "icon-section",
                    style: { backgroundColor: form.color },
                  },
                  [
                    _c("i", { staticClass: "md-icon" }, [
                      _vm._v("text_snippet"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-section" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(form.title)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "arrow-section" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        position: "relative",
                        display: "inline-block",
                      },
                    },
                    [
                      _c(
                        "i",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: { content: "Düzenle", placement: "top" },
                              expression:
                                "{ content: 'Düzenle', placement: 'top' }",
                            },
                          ],
                          staticClass: "md-icon",
                          staticStyle: { color: "mediumseagreen" },
                          on: {
                            click: function ($event) {
                              return _vm.editForm(form._id)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            edit\n                        "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        position: "relative",
                        display: "inline-block",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.inboxForm(form._id)
                        },
                      },
                    },
                    [
                      _c(
                        "i",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                content: "Gelen Kutusu",
                                placement: "top",
                              },
                              expression:
                                "{ content: 'Gelen Kutusu', placement: 'top' }",
                            },
                          ],
                          staticClass: "md-icon",
                          staticStyle: { color: "cornflowerblue" },
                        },
                        [
                          _vm._v(
                            "\n                            inbox\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      form.unreadCount
                        ? _c("span", { staticClass: "badge" }, [
                            _vm._v(_vm._s(form.unreadCount)),
                          ])
                        : _c("span", { staticClass: "badge" }, [_vm._v("0")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        position: "relative",
                        display: "inline-block",
                      },
                    },
                    [
                      _c(
                        "i",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: { content: "Sil", placement: "top" },
                              expression:
                                "{ content: 'Sil', placement: 'top' }",
                            },
                          ],
                          staticClass: "md-icon",
                          staticStyle: { color: "orangered" },
                          on: {
                            click: function ($event) {
                              return _vm.showDeleteModal(form)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            delete\n                        "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "info-box",
          style: { borderRightColor: _vm.selectedFormColor },
        },
        [
          _c("div", { style: { borderBottomColor: _vm.selectedFormColor } }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.selectedForm ? _vm.selectedForm.title : "") +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("form.totalResponse")) +
                ": " +
                _vm._s(_vm.selectedForm ? _vm.selectedForm.total : 0) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("form.totalUnreadResponse")) +
                ": " +
                _vm._s(_vm.selectedForm ? _vm.selectedForm.unreadCount : 0) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("form.totalReadResponse")) +
                ": " +
                _vm._s(_vm.selectedForm ? _vm.selectedForm.readCount : 0) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("form.totalArchivedResponse")) +
                ": " +
                _vm._s(_vm.selectedForm ? _vm.selectedForm.archivedCount : 0) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "button-group" }, [
            _c(
              "button",
              {
                style: { backgroundColor: _vm.selectedFormColor },
                on: {
                  click: function ($event) {
                    return _vm.viewForm(_vm.selectedForm._id)
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("form.formView")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                style: { backgroundColor: _vm.selectedFormColor },
                on: {
                  click: function ($event) {
                    return _vm.editForm(_vm.selectedForm._id)
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("form.formEdit")) +
                    "\n            "
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.deleteModal
        ? _c("DeleteModal", {
            attrs: {
              description:
                "Bu formu sildiğiniz takdirde, forma ait tüm veriler kalıcı olarak silinecektir. Devam etmek istediğinizden emin misiniz?",
              btnCancelText: _vm.$t("message.cancel"),
              btnoktext: _vm.$t("message.delete"),
            },
            on: {
              cancel: function ($event) {
                _vm.deleteModal = false
              },
              confirm: _vm.confirmDelete,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-logo" }, [
      _c("span", { staticClass: "md-icon" }, [_vm._v("document_scanner")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }